import { Download, Lock } from 'lucide-react';
import { useFeature, upgradeHintFor } from '../lib/features';
import { api } from '../api/client';
import { toast } from '../lib/toast';

// Small reusable button that downloads a CSV from a per-domain export
// endpoint. Hidden / locked for users without the `csvExports` feature flag.
//
// Usage:
//   <CsvExportButton domainId={domain._id} kind="audits" label="Export audits" />
//   <CsvExportButton domainId={domain._id} kind="ai-traffic" label="Export traffic" />
//   <CsvExportButton domainId={domain._id} kind="keywords" label="Export keywords" />
export default function CsvExportButton({ domainId, kind, label = 'Export CSV', size = 'sm' }) {
  const unlocked = useFeature('csvExports');

  async function handleDownload() {
    try {
      const res = await api.get(`/api/domains/${domainId}/exports/${kind}.csv`, {
        responseType: 'blob',
      });
      const cd = res.headers['content-disposition'] || '';
      const match = /filename="([^"]+)"/.exec(cd);
      const filename = match ? match[1] : `${kind}.csv`;
      const blob = new Blob([res.data], { type: 'text/csv' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      setTimeout(() => {
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
      }, 100);
    } catch (err) {
      toast.error(err, 'CSV export failed');
    }
  }

  if (!unlocked) {
    return (
      <button
        type="button"
        className={`btn-ghost ${size === 'sm' ? 'text-xs' : 'text-sm'}`}
        title={`${label} — requires ${upgradeHintFor('csvExports')}`}
        onClick={() => toast.error(`CSV export is a ${upgradeHintFor('csvExports')} feature.`)}
      >
        <Lock className="w-3.5 h-3.5" />
        {label}
      </button>
    );
  }

  return (
    <button
      type="button"
      className={`btn-ghost ${size === 'sm' ? 'text-xs' : 'text-sm'}`}
      onClick={handleDownload}
    >
      <Download className="w-3.5 h-3.5" />
      {label}
    </button>
  );
}
